






import { Component, Vue } from 'vue-property-decorator'
import ChangePasswordDialog from "@/components/dialog/ChangePasswordDialog.vue";

@Component({
  components: { ChangePasswordDialog }
})
export default class DialogWrapper extends Vue {

}
